import { Component } from '@angular/core';

@Component({
    selector: 'elight-unsaved-data-dialog',
    templateUrl: './unsaved-data-dialog.component.html',
    styleUrls: ['./unsaved-data-dialog.component.scss'],
})
export class UnsavedDataDialogComponent {}
